import { render, staticRenderFns } from "./Healthcare.vue?vue&type=template&id=62b0a9ae&scoped=true&"
import script from "./Healthcare.vue?vue&type=script&lang=js&"
export * from "./Healthcare.vue?vue&type=script&lang=js&"
import style0 from "./Healthcare.vue?vue&type=style&index=0&id=62b0a9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0a9ae",
  null
  
)

export default component.exports